import { render, staticRenderFns } from "./specialTestList.vue?vue&type=template&id=be15e00a"
import script from "./specialTestList.vue?vue&type=script&lang=js"
export * from "./specialTestList.vue?vue&type=script&lang=js"
import style0 from "./specialTestList.vue?vue&type=style&index=0&id=be15e00a&prod&lang=less"
import style1 from "./specialTestList.vue?vue&type=style&index=1&id=be15e00a&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports